module.exports = __webpack_public_path__ + "static/img/search_top.fd4de29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/System/search_top.png
// module id = BkDp
// module chunks = 3